import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import ChemicalCompositionDetails from "./ChemicalCompositonDetailsModal";
import PropertiesDialogPopUp from "./PropertiesDialogPopUp";
import axios from "axios";
import viewEyeIcon from "./../../../../Assets/Icons/viewEyeIcon.svg";
import editPenIcon from "./../../../../Assets/Icons/editPenIcon.svg";
import deleteBinIcon from "./../../../../Assets/Icons/deleteBinIcon.svg";
import TablePagination from "./TablePagination";

import { useNavigate } from "react-router-dom";
import { useAuthenticatedUser } from "../../../../../hooks/useAuthenticatedUser";
import { joinNameWithoutSpaces } from "../../../../../utils/helper";
const BaseUrl = process.env.REACT_APP_API_V1_URL;
const ChemicalCompositionTableHeadings = () => {
  return (
    <div className="relative bg-blue w-full flex flex-row p-[0.75rem] box-border items-end justify-start gap-[0.75rem] text-left text-[0.88rem] text-white font-roboto">
      <div className="flex-1 flex flex-col items-start justify-start">
        <div className="relative font-semibold text-left w-full sm:w-[calc(11rem / 1.6)]">
          Sr No.
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="relative font-semibold text-left w-full sm:w-[calc(34rem / 1.6)]">
          Element Name
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="relative font-semibold text-center w-full sm:w-[calc(11rem / 1.6)]">
          Min Value(%)
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="relative font-semibold text-center w-full sm:w-[calc(11rem / 1.6)]">
          Max Value(%)
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="relative font-semibold text-center w-full sm:w-[calc(11rem / 1.6)]">
          Created Date
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="relative font-semibold text-center w-full sm:w-[calc(11rem / 1.6)]">
          Last Modified
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="relative font-semibold text-center w-full sm:w-[calc(11rem / 1.6)]">
          Action
        </div>
      </div>
    </div>
  );
};

const ChemicalCompositionTable = ({
  records = [],
  associatedGrade,
  updateGradeProperties,
}) => {
  const { user } = useAuthenticatedUser();
  const [open, setOpen] = useState(false);
  const [dialogType, setDialogType] = useState(0);
  const [chemicalCompositionData, setChemicalCompositionData] =
    useState(records);

  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [status, setStatus] = useState("");
  const [sorting, setSorting] = useState("name,desc");
  const [selectedCC, setSelectedCC] = useState({});
  const [recordIndex, setRecordIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  const handleOpenDialog = (type) => {
    setDialogType(type);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  useEffect(() => {
    const newData = customFilterFunction(records, sorting, searchQuery);
    setChemicalCompositionData(newData);
  }, [sorting, searchQuery, associatedGrade]);

  const addFormDataToCCProperties = (
    formData,
    associatedGrade,
    recordId = null
  ) => {
    const { name } = formData;
    const { id } = formData;
    if (associatedGrade.chemicalComposition === null || associatedGrade.chemicalComposition.length === 0) {
      associatedGrade.chemicalComposition = [];
    } else {
      if (typeof (associatedGrade.chemicalComposition) === "string") {
        associatedGrade.chemicalComposition = JSON.parse(
          associatedGrade.chemicalComposition
        );
      }
    }
    let flag = true;
/** TODO refactor the condition 
**/
    if (associatedGrade.chemicalComposition.length === 0) {
      associatedGrade.chemicalComposition.push(formData);
    } else {
      const isAlreadyExists = associatedGrade.chemicalComposition.some(
        (property) => property.name === name || property.id === id
      );

      if (isAlreadyExists) {
        let index = associatedGrade.chemicalComposition.findIndex((element) => element.id === id);
        if (index > -1 && dialogType === 2) {
          let indexFromNameAndId = associatedGrade.chemicalComposition.findIndex((element) => element.name === name && element.id !== id);
          if (indexFromNameAndId > -1) {
            window.alert("Chemical Composition already exists")
            return;
          } else {
            associatedGrade.chemicalComposition[index] = formData;
          }
        } else if (dialogType === 0) {
          window.alert("Chemical Composition already exists")
          return;
        } else {
          const maxId = associatedGrade.chemicalComposition.reduce((max, obj) => (obj.id > max ? obj.id : max), 0);
          if ((maxId + 1) === recordId) {
            associatedGrade.chemicalComposition.push(formData);
          }
        }
      } else {
        associatedGrade.chemicalComposition.push(formData);
      }
    }
    associatedGrade.chemicalComposition = JSON.stringify(
      associatedGrade.chemicalComposition
    );

    return flag;
  };

  const handleViewElement = () => { };

  const updateTensileProperties = async (gradeData) => {
    const apiUrl = `${BaseUrl}/quality-grade/${gradeData.id}`;
    const httpMethod = "PUT";
    const response = await axios({
      method: httpMethod,
      url: apiUrl,
      data: gradeData,
      headers: {
        Authorization: `${user.token}`,
        "Content-Type": "application/json",
      },
    });
    return response;
  };

  const handleEditElement = async (formData, recordId) => {

    try {

      const chemicalComposition = JSON.parse(associatedGrade.chemicalComposition);
      chemicalComposition.forEach((composition) => {
        composition.name = joinNameWithoutSpaces(composition.name);
      });

      associatedGrade.chemicalComposition = JSON.stringify(chemicalComposition);
      if (!addFormDataToCCProperties(formData, associatedGrade, recordId)) {
        return;
      }

      var returnResponse = await updateTensileProperties(associatedGrade);
      if (returnResponse.status === 200) {
        updateGradeProperties(returnResponse.data.data);
        handleCloseDialog();
      }
    } catch (error) {
      alert("Encountered Error in creating/Updating Properies");
      return false;
    }
  };

  const deleteChemicalProperty = async (chemicalIndex, chemicalRecords) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this Chemical Property?"
      );
      if (confirmDelete) {
        const ChemicalCompositionArray = chemicalRecords;
        const updatedChemicalComposition = ChemicalCompositionArray.filter(
          (record, index) => record.id !== chemicalIndex
        );

        const updatedChemicalCompositionsString = JSON.stringify(
          updatedChemicalComposition
        );

        const updatedGrade = {
          ...associatedGrade,
          chemicalComposition: updatedChemicalCompositionsString,
        };
        var returnResponse = await updateTensileProperties(updatedGrade);

        if (returnResponse.status === 200) {
          updateGradeProperties(returnResponse.data.data);
        }
      }
    } catch (error) {
      return false;
    }
  };

  const customFilterFunction = (data, sorting, searchQuery) => {
    // return []
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }
    const [field, order] = sorting.split(",");

    let filteredData = [...data];

    if (searchQuery) {
      filteredData = filteredData.filter((item) => {
        const nameMatches = item.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        return nameMatches;
      });
    }

    const sortedData = [...filteredData].sort((a, b) => {
      if (order === "asc") {
        return a[field].localeCompare(b[field]);
      } else {
        return b[field].localeCompare(a[field]);
      }
    });

    return sortedData;
  };

  const handleCustomSearch = (value) => {
    setSearchQuery(value);
  };
  const handleCustomSort = (value) => {
    setSorting(value);
  };

  const ChemicalCompositionTableRecords = ({ records }) => {
    if (typeof records === "string") {
      try {
        records = JSON.parse(records);
      } catch (error) {
        console.error("Error parsing string to array:", error);
        records = [];
      }
    }

    if (!Array.isArray(records) || records.length === 0) {
      return null;
    }
    return (
      <>
        {records.map((record, index) => (
          <div
            key={index}
            className="catalogue-details self-stretch flex flex-row p-[0.75rem] items-center justify-start gap-[0.75rem] border-b border-gray-300"
          >
            <div className="flex-1 flex flex-col items-center justify-start">
              <div className="relative  w-full sm:w-[calc(11rem / 1.6)]   text-left ">
                {index + 1}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-start">
              <div className="relative  w-full sm:w-[calc(34rem / 1.6)]   text-left ">
                {record.name}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-start">
              <div className="relative  w-full sm:w-[calc(11rem / 1.6)]   text-center ">
                {record.minimum}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-start">
              <div className="relative  w-full sm:w-[calc(11rem / 1.6)]   text-center ">
                {record.maximum}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-start">
              <div className="relative  w-full sm:w-[calc(11rem / 1.6)]   text-center ">
                {record.createdAt}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-start">
              <div className="relative  w-full sm:w-[calc(11rem / 1.6)]   text-center ">
                {record.updatedAt}
              </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-start text-center ">
              <div className="relative  w-full sm:w-[calc(11rem / 1.6)]  text-center">
                <button
                  className="relative w-[1.13rem] h-[1.13rem] overflow-hidden shrink-0 mr-2 text-center "
                  onClick={(e) => {
                    handleOpenDialog(1);
                    setSelectedCC(record);
                    setRecordIndex(record?.id);
                  }}
                >
                  <img className="w-full h-full" alt="" src={viewEyeIcon} />
                </button>

                <button
                  className="relative w-[1.13rem] h-[1.13rem] overflow-hidden shrink-0 mr-2 text-center "
                  onClick={(e) => {
                    handleOpenDialog(2);
                    setSelectedCC(record);
                    setRecordIndex(record?.id);
                  }}
                >
                  <img className="w-full h-full" alt="" src={editPenIcon} />
                </button>

                <button
                  className="relative w-[1.13rem] h-[1.13rem] overflow-hidden shrink-0 text-center "
                  onClick={(e) => deleteChemicalProperty(record?.id, records)}
                >
                  <img className="w-full h-full" alt="" src={deleteBinIcon} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="w-full">
      {" "}
      <div className="self-stretch flex flex-row items-center justify-between gap-[12px] text-xl text-blue mt-5 mb-3">
        <div>Chemical Composition</div>

        <button
          className="rounded bg-customBlue overflow-hidden flex py-2 px-4 items-center justify-center text-lg text-white font-semibold"
          onClick={(e) => handleOpenDialog(0)}
        >
          Add New Chemical Composition
        </button>
      </div>
      <div className="flex justify-between mb-3">
        <div className="flex gap-x-5">
          <FormControl sx={{ width: "250px" }}>
            <InputLabel id="sorting-label">Sort</InputLabel>
            <Select
              labelId="sorting-label"
              id="sorting-select"
              label="Sort"
              value={sorting}
              onChange={(e) => handleCustomSort(e.target.value)}
              sx={{ width: "180%", maxWidth: "250px" }}
            // sx={{ width: "250px" }}
            >
              <MenuItem value="name,asc">Element Name(Ascending)</MenuItem>
              <MenuItem value="name,desc">Element Name(Descending)</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div>
          <FormControl
            sx={{ width: "345px" }}
          >
            <TextField
              className={`h-[3rem] block w-full p-1 border border-gray-500 rounded-md focus:outline-none ring-blue-500 focus:border-blue-500`}
              id="outlined-basic"
              label="Search by Name"
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => handleCustomSearch(e.target.value)}
            />
          </FormControl>
        </div>
      </div>
      <ChemicalCompositionTableHeadings />
      {chemicalCompositionData?.length === 0 && <div className="text-center pt-4">No Chemical Composition Data Available</div>}
      <ChemicalCompositionTableRecords records={chemicalCompositionData} />
      {/* <TablePagination
        pageNumber={pageNumber}
        pageSize={pageSize}
        handlePageSize={setPageSize}
        handlePageNumber={setPageNumber}
        totalRecordsData={totalRecords}
      /> */}
      <PropertiesDialogPopUp open={open} onClose={handleCloseDialog}>
        {dialogType === 0 && (
          <ChemicalCompositionDetails
            type={"ADD"}
            onClose={handleCloseDialog}
            record={null}
            itemindex={null}
            handleAction={handleEditElement}
            associatedGrade={associatedGrade}
            fullData={chemicalCompositionData}
          />
        )}

        {dialogType === 1 && (
          <ChemicalCompositionDetails
            type={"VIEW"}
            onClose={handleCloseDialog}
            record={selectedCC}
            itemindex={recordIndex}
            handleAction={handleViewElement}
            associatedGrade={associatedGrade}
            fullData={chemicalCompositionData}
          />
        )}

        {dialogType === 2 && (
          <ChemicalCompositionDetails
            type={"EDIT"}
            onClose={handleCloseDialog}
            record={selectedCC}
            itemindex={recordIndex}
            handleAction={handleEditElement}
            associatedGrade={associatedGrade}
            fullData={chemicalCompositionData}
          />
        )}
      </PropertiesDialogPopUp>
    </div>
  );
};
export default ChemicalCompositionTable;
